module.exports = __webpack_public_path__ + "img/toplogo.cc3d8c56.png";